/* HW · Klaviyo "Added to Cart" custom event tracker
   Re-creates the custom Added to Cart event that the legacy theme
   fired on click of PDP add-to-cart button via:
     klaviyo.push(['track', 'Added to Cart', item])

   Source legacy: hw-livethe/layout/theme.liquid:521-538
   The legacy fired with undefined `item`. This version sends a proper
   payload aligned with Klaviyo's recommended schema for Abandoned Cart
   flows.

   Detection method: subscribes to Broadcast's PUB_SUB_EVENTS.cartUpdate
   and compares cart item_count before/after. Fires only when items
   were added (count increased).

   Migrated: 2026-06-22 */
(function () {
  'use strict';

  var previousItemCount = null;

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function buildPayload(cart, addedItem) {
    var origin = window.location.origin;
    return {
      $value: cart.total_price / 100,
      AddedItemProductName: addedItem.product_title,
      AddedItemProductID: addedItem.product_id,
      AddedItemSKU: addedItem.sku,
      AddedItemImageURL: addedItem.image,
      AddedItemURL: origin + addedItem.url,
      AddedItemPrice: addedItem.final_price / 100,
      AddedItemQuantity: addedItem.quantity,
      ItemNames: cart.items.map(function (item) { return item.product_title; }),
      CheckoutURL: origin + '/checkout',
      Items: cart.items.map(function (item) {
        return {
          ProductName: item.product_title,
          ProductID: item.product_id,
          SKU: item.sku,
          ImageURL: item.image,
          URL: origin + item.url,
          Price: item.final_price / 100,
          Quantity: item.quantity
        };
      })
    };
  }

  function trackAddedToCart(payload) {
    if (window._klOnsite && typeof window._klOnsite.push === 'function') {
      window._klOnsite.push(['track', 'Added to Cart', payload]);
    } else if (window.klaviyo && typeof window.klaviyo.track === 'function') {
      window.klaviyo.track('Added to Cart', payload);
    }
  }

  function handleCartUpdate() {
    fetchCart().then(function (cart) {
      if (previousItemCount !== null && cart.item_count > previousItemCount) {
        var addedItem = cart.items[cart.items.length - 1];
        if (addedItem) {
          trackAddedToCart(buildPayload(cart, addedItem));
        }
      }
      previousItemCount = cart.item_count;
    });
  }

  function init() {
    fetchCart().then(function (cart) {
      previousItemCount = cart.item_count;
    });

    if (window.subscribe && window.theme && window.theme.PUB_SUB_EVENTS) {
      window.subscribe(window.theme.PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
